import { UseQueryOptions, useQuery } from "@tanstack/react-query"
import { APIS_KEYS } from "../../apis-keys"
import { IResponseGetAllChannels } from "./types"
import type { AxiosInstance, AxiosResponse } from "axios"
import { useApi } from "../../useApi"
import { AllChannelsURL } from "../../../utils/constants"

async function getAllChannels(apiPrivate: AxiosInstance) {
	try {
		const response: AxiosResponse<IResponseGetAllChannels> =
			await apiPrivate.get(`${AllChannelsURL}`, {})
		return response.data
	} catch (error: any) {
		console.log(error)
		throw new Error("something went wrong")
	}
}

export function useGetAllChannels(
	options?:
		| Omit<
				UseQueryOptions<
					IResponseGetAllChannels,
					unknown,
					IResponseGetAllChannels
				>,
				"queryKey" | "queryFn"
		  >
		| undefined
) {
	const { apiPrivate } = useApi()
	return useQuery({
		queryKey: [APIS_KEYS.GETCALENDERDATA],
		queryFn: () => getAllChannels(apiPrivate),
		...options,
	})
}
